// In-app confirmations instead of the browser's window.confirm: `await ask(text, { action, tone })` is true when the
// person confirms. The question is the first sentence of `text`; the rest says what happens. ConfirmHost shows it.
import Vue from 'vue';

export const confirmState = Vue.observable({ open: false, text: '', action: 'Confirm', tone: '', resolve: null });

export function ask(text, options) {
  const settings = options || {};
  if (confirmState.resolve) confirmState.resolve(false);
  return new Promise(resolve => {
    Object.assign(confirmState, { open: true, text: String(text || ''), action: settings.action || 'Confirm',
      tone: settings.tone || '', resolve });
  });
}

export function answer(value) {
  const resolve = confirmState.resolve;
  confirmState.open = false;
  confirmState.resolve = null;
  if (resolve) resolve(!!value);
}
